import * as React from 'react'

import { TryInStoreBanner, TryInStoreProvider } from '@grandvisionhq/fun-try-in-store'
import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/contact-lens'
import { FullDateDeliveryIndicatorContainer } from '@grandvisionhq/www-next/slot-components/FullDateDeliveryIndicatorContainer'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { settings as cartSettings } from '../../../components/hocs/with-cart'
import { clSpecifications } from '../../../configuration'

const slots: Props['slots'] = {
  DynamicDeliveryIndicator: FullDateDeliveryIndicatorContainer,
  TopBanner: TryInStoreBanner,
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => (
  <TryInStoreProvider>
    <Page
      {...props}
      slots={slots}
      maxOrderableQuantity={cartSettings.maximumQuantity}
      specificationConfiguration={clSpecifications}
    />
  </TryInStoreProvider>
)

ProductDetailPage.getInitialProps = Page.getInitialProps

export default composePDP<Props>(ProductDetailPage)
